import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import dayjs from 'dayjs';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getDaysSinceFirstMondayOfYear(year?: number): number {
  const currentYear = year ?? dayjs().year();
  const today = dayjs();

  // Start from January 1st of the specified year
  let firstMonday = dayjs().year(currentYear).month(0).date(1);

  // Find the first Monday of the year
  // If January 1st is not Monday (day 1), find the next Monday
  if (firstMonday.day() !== 1) {
    firstMonday = firstMonday.day(1); // Move to Monday of the same week
  }

  // Calculate the difference in days
  const diffDays = today.diff(firstMonday, 'day');

  return Math.max(0, diffDays);
}

export function getWeekNumber(dateString: string): number {
  return dayjs(dateString).week();
}
